import React from "react";
import { connect } from "react-redux";
import PasswordChecklist from "react-password-checklist";

import { setIsPasswordValid } from "../../../../../../../actions/form";
import { decrypt } from "../../../utils/code";

const iconComponents = {
  ValidIcon: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M9.99951 1.90723C5.53695 1.90723 1.90625 5.53809 1.90625 10.0005C1.90625 14.4629 5.53695 18.0938 9.99951 18.0938C14.4621 18.0938 18.0928 14.4635 18.0928 10.0005C18.0928 5.53745 14.4614 1.90723 9.99951 1.90723ZM9.99951 17.1154C6.07618 17.1154 2.88347 13.9233 2.88347 10.0005C2.88347 6.07764 6.07618 2.88508 9.99951 2.88508C13.9228 2.88508 17.1151 6.07716 17.1151 10.0005C17.1151 13.9238 13.9228 17.1154 9.99951 17.1154Z"
      fill="#007D32"/>
    <path
      d="M13.1206 7.58634L8.75753 11.9488L6.87561 10.0668C6.75466 9.93362 6.54862 9.92367 6.4154 10.0446C6.28218 10.1656 6.27223 10.3716 6.39317 10.5048C6.40022 10.5126 6.40764 10.52 6.4154 10.527L8.52742 12.6403C8.65443 12.7674 8.86041 12.7675 8.98749 12.6405C8.98745 12.6405 8.98754 12.6404 8.98749 12.6405L13.5808 8.04781C13.7082 7.92073 13.7085 7.7144 13.5814 7.58697C13.4543 7.45954 13.248 7.45925 13.1206 7.58634Z"
      fill="#007D32"/>
  </svg>,
  InvalidIcon: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M9.99951 1.90674C5.53743 1.90674 1.90625 5.5376 1.90625 10C1.90625 14.4624 5.53774 18.0933 9.99951 18.0933C14.4613 18.0933 18.0928 14.4629 18.0928 10C18.0928 5.53712 14.4619 1.90674 9.99951 1.90674ZM9.99951 17.1154C6.07603 17.1154 2.88379 13.9232 2.88379 10.0002C2.88379 6.07715 6.07634 2.88444 9.99951 2.88444C13.9227 2.88444 17.1146 6.07667 17.1146 10.0002C17.1146 13.9236 13.9227 17.1154 9.99951 17.1154Z"
      fill="#CC0935"/>
    <path
      d="M10.4472 10.0004L12.9821 7.46545C13.1153 7.34451 13.1253 7.13846 13.0043 7.00524C12.8834 6.87202 12.6774 6.86207 12.5441 6.98302C12.5364 6.99006 12.529 6.99748 12.5219 7.00524L9.98666 9.5397L7.45141 7.00445C7.31819 6.88351 7.11215 6.89346 6.9912 7.02668C6.87843 7.15089 6.87843 7.34044 6.9912 7.46466L9.52598 10.0004L6.99073 12.5356C6.85896 12.658 6.85138 12.8641 6.97378 12.9958C7.09618 13.1276 7.30222 13.1352 7.43398 13.0128C7.43984 13.0074 7.44549 13.0017 7.45093 12.9958L9.98666 10.4611L12.5221 12.9965C12.6445 13.1282 12.8505 13.1358 12.9823 13.0134C13.114 12.891 13.1216 12.685 12.9992 12.5532C12.9938 12.5474 12.9881 12.5417 12.9823 12.5363L10.4472 10.0004Z"
      fill="#CC0935"/>
  </svg>
}


const PasswordTips = ({ password, requirements, isPasswordValid, setIsPasswordValid }) => {
  if (!requirements) return null;
  const { title, rules, minLength, messages } = requirements;

  return (
    <div className={"password-tips"}>
      <span className={"password-tips__title"}>{title}</span>
      <PasswordChecklist
        rules={rules}
        minLength={minLength}
        messages={messages}
        value={password}
        onChange={(isValid) => {
          (isValid !== isPasswordValid) && setIsPasswordValid(isValid);
        }}
        invalidTextColor={"#000"}
        validTextColor={"#000"}
        iconComponents={iconComponents}
      />
    </div>
  )
}
const mapStateToProps = (state) => {
  return {
    password: decrypt(state.formData.password),
    rePassword: decrypt(state.formData.rePassword),
    isPasswordValid: state.isPasswordValid
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setIsPasswordValid: (isValid) => dispatch(setIsPasswordValid(isValid))
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(PasswordTips);
